<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 960">
    <title>Vai</title>
    <path
      d="M359.5 699.5h0c-11.874-11.874-11.874-31.126 0-43L536 480 359.5 303.5c-11.874-11.874-11.874-31.126 0-43h0c11.874-11.874 31.126-11.874 43 0l198 198c11.874 11.874 11.874 31.126 0 43l-198 198c-11.874 11.874-31.126 11.874-43 0z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
